export default __webpack_public_path__ + "assets/cosmos_safari.47e47574.png";